import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService } from '../../../../core';
import { RegiaoCidadeSubRegiao } from './regiao-cidade-sub-regiao';
import { RegiaoCidade } from '../regiao-cidade';
import { CidadeCrudHttpService } from '../../../cidade';
import { CidadeSubRegiao } from '../../../cidade/sub-regiao';
import { RegiaoCidadeSubRegiaoBairro } from './regiao-cidade-sub-regiao-bairro';
import { CidadeSubRegiaoBairro } from '../../../cidade/bairro';

@Component({
    selector: 'sgt-regiao-cidade-sub-regiao',
    templateUrl: './regiao-cidade-sub-regiao.component.html',
    styleUrls: ['./regiao-cidade-sub-regiao.component.less']
})
export class RegiaoCidadeSubRegiaoComponent implements OnInit {
    elModal: any;

    @ViewChild('form') form: NgForm;
    regiaoCidade: RegiaoCidade;

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private cidadeCrudHttpService: CidadeCrudHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#regiaoCidadeSubRegioes').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    open(regiaoCidade: RegiaoCidade) {
        this.regiaoCidade = regiaoCidade;
        // this.form.resetForm();

        // Carregando as sub-regiões da cidade
        this.carregarSubRegioes(regiaoCidade);

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Carrega as sub-regiões e seus bairros da cidade informada */
    private carregarSubRegioes(regiaoCidade: RegiaoCidade) {
        if (!regiaoCidade || !regiaoCidade.idCidade) {
            return;
        }

        this.cidadeCrudHttpService.load(regiaoCidade.idCidade)
            .subscribe(
                cidade => {
                    if (cidade.subRegioes) {
                        cidade.subRegioes.forEach(subRegiao => {
                            let regiaoCidadeSubRegiao = this.getSubRegiao(regiaoCidade.subRegioes, subRegiao);
                            if (!regiaoCidadeSubRegiao) {
                                regiaoCidadeSubRegiao = new RegiaoCidadeSubRegiao();
                                regiaoCidadeSubRegiao.isChecked = false;
                                regiaoCidadeSubRegiao.idRegiaoCidade = regiaoCidade.id;
                                regiaoCidadeSubRegiao.idCidadeSubRegiao = subRegiao.id;
                                regiaoCidadeSubRegiao.cidadeSubRegiao = subRegiao;
                                regiaoCidade.subRegioes.push(regiaoCidadeSubRegiao);
                            }

                            // Bairros
                            if (subRegiao.bairros) {
                                subRegiao.bairros.forEach(bairro => {
                                    let regiaoCidadeSubRegiaoBairro = this.getBairro(regiaoCidadeSubRegiao.bairros, bairro);
                                    if (!regiaoCidadeSubRegiaoBairro) {
                                        regiaoCidadeSubRegiaoBairro = new RegiaoCidadeSubRegiaoBairro();
                                        regiaoCidadeSubRegiaoBairro.isChecked = false;
                                        regiaoCidadeSubRegiaoBairro.idRegiaoCidadeSubRegiao = regiaoCidadeSubRegiao.id;
                                        regiaoCidadeSubRegiaoBairro.idCidadeSubRegiaoBairro = bairro.id;
                                        regiaoCidadeSubRegiaoBairro.cidadeSubRegiaoBairro = bairro;
                                        regiaoCidadeSubRegiao.bairros.push(regiaoCidadeSubRegiaoBairro);
                                    }
                                });
                            }
                        });
                    }
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao carregar as sub-regiões da cidade', error)
            );
    }

    /** Tenta obter a sub-região nas sub-regiões atuais da cidade da região */
    private getSubRegiao(subRegioesAtuais: RegiaoCidadeSubRegiao[], subRegiao: CidadeSubRegiao): RegiaoCidadeSubRegiao {
        if (!subRegioesAtuais) {
            return null;
        }

        for (let i = 0; i < subRegioesAtuais.length; i++) {
            const entity = subRegioesAtuais[i];
            if (entity.idCidadeSubRegiao === subRegiao.id) {
                return entity;
            }
        }
        return null;
    }

    /** Tenta obter o bairro nos bairros atuais da sub-região da cidade da região */
    private getBairro(bairrosAtuais: RegiaoCidadeSubRegiaoBairro[], bairro: CidadeSubRegiaoBairro): RegiaoCidadeSubRegiaoBairro {
        if (!bairrosAtuais) {
            return null;
        }

        for (let i = 0; i < bairrosAtuais.length; i++) {
            const entity = bairrosAtuais[i];
            if (entity.idCidadeSubRegiaoBairro === bairro.id) {
                return entity;
            }
        }
        return null;
    }

    /** Resolve as sub-regiões e seus bairros, removendo aqueles que não estão selecionados ("checkados") */
    resolve(regiaoCidade: RegiaoCidade) {
        if (!regiaoCidade || !regiaoCidade.subRegioes) {
            return;
        }
        for (let i = regiaoCidade.subRegioes.length; i--; ) {
            const entity = regiaoCidade.subRegioes[i];

            // Bairros
            this.resolveBairros(entity);

            if (!entity.isChecked) {
                regiaoCidade.subRegioes.splice(i, 1);
            }
        }
    }

    /** Resolve os bairros da sub-região, removendo aqueles que não estão selecionados ("checkados") */
    private resolveBairros(regiaoCidadeSubRegiao: RegiaoCidadeSubRegiao) {
        if (!regiaoCidadeSubRegiao || !regiaoCidadeSubRegiao.bairros) {
            return;
        }
        for (let i = regiaoCidadeSubRegiao.bairros.length; i--; ) {
            const entity = regiaoCidadeSubRegiao.bairros[i];
            if (!entity.isChecked) {
                regiaoCidadeSubRegiao.bairros.splice(i, 1);
            }
        }
    }

    /** Ao alterar o check de uma sub-região */
    onChangeCheckSubRegiao(subRegiao: RegiaoCidadeSubRegiao) {
        if (!subRegiao) {
            return;
        }

        for (let i = 0; i < subRegiao.bairros.length; i++) {
            const bairro = subRegiao.bairros[i];
            bairro.isChecked = subRegiao.isChecked;
        }
    }

    /** Ao alterar o check de um bairro */
    onChangeCheckBairro(subRegiao: RegiaoCidadeSubRegiao) {
        if (!subRegiao) {
            return;
        }

        let possuiAlgumCheckado = false;
        for (let i = 0; i < subRegiao.bairros.length; i++) {
            const bairro = subRegiao.bairros[i];
            if (bairro.isChecked) {
                possuiAlgumCheckado = true;
                break;
            }
        }

        subRegiao.isChecked = possuiAlgumCheckado;
    }
}
